import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ToastHost from "./components/ToastHost";
import ScrollToTop from "./components/ScrollToTop";
import SmoothScroll from "./components/SmoothScroll";
import BackToTop from "./components/BackToTop";
import AdminApp from "./appcomponents/AdminApp";
import ProtectedRoute from "./appcomponents/ProtectedRoute";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Home from "./Home";
import About from "./About";
import Services from "./Services";
import NeurofeedbackBeyond from "./Services/NeurofeedbackBeyond";
import BrainZenPro from "./Services/NeurofeedbackBeyond/BrainZenPro";
import BrainMemoryCare from "./Services/NeurofeedbackBeyond/BrainMemoryCare";
import AllergyTesting from "./Services/AllergyTesting";
import MedicalBilling from "./Services/MedicalBilling";
import MiniCArmInjections from "./Services/MiniCArmInjections";
import AdvancedWoundCare from "./Services/AdvancedWoundCare";
import Flow7TestingDysfunction from "./Services/Flow7TestingDysfunction";
import InHouseLabServices from "./Services/InHouseLabServices";
import ToxicologyLaboratorySolutions from "./Services/ToxicologyLaboratorySolutions";
import MarketingServices from "./Services/MarketingServices";
import TranscranialMagneticStimulation from "./Services/TranscranialMagneticStimulation";
import EmrSubscription from "./Services/EmrSubscription";
// import Blog from "./Blog";
// import BlogDetail from "./BlogDetail";
import Contact from "./Contact";
import FrequentlyAsked from "./FrequentlyAsked";
import TermsConditions from "./TermsConditions";
import NotFound from "./NotFound";

function SiteLayout() {
  return (
    <SmoothScroll>
      <div id="smooth-wrapper" className="smoothWrapper">
        <Header />
        <div id="smooth-content" className="smoothContent App">
          <ScrollToTop />
          <Outlet />
          <Footer />
        </div>
        <BackToTop />
      </div>
    </SmoothScroll>
  );
}

function CanonicalPath({ children }) {
  const location = useLocation();

  const cleanedPathname = location.pathname.replace(/\/{2,}/g, "/");
  const normalizedPathname =
    cleanedPathname === "/"
      ? "/"
      : `${cleanedPathname.replace(/\/+$/, "")}/`;

  if (normalizedPathname !== location.pathname) {
    return (
      <Navigate
        replace
        to={`${normalizedPathname}${location.search}${location.hash}`}
      />
    );
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ToastHost />
      <CanonicalPath>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/neurofeedback" element={<NeurofeedbackBeyond />} />
            <Route path="/services/brain-zen-pro" element={<BrainZenPro />} />
            <Route path="/services/brain-memory-care" element={<BrainMemoryCare />} />
            <Route path="/services/allergy-testing" element={<AllergyTesting />} />
            <Route path="/services/medical-billing-services" element={<MedicalBilling />} />
            <Route path="/services/osteoarthritis-injections" element={<MiniCArmInjections />} />
            <Route path="/services/advance-wound-care" element={<AdvancedWoundCare />} />
            <Route
              path="/services/tm-flow-testing-dysfunction"
              element={<Flow7TestingDysfunction />}
            />
            <Route path="/services/in-house-lab-services" element={<InHouseLabServices />} />
            <Route
              path="/services/toxicology-laboratory-solutions"
              element={<ToxicologyLaboratorySolutions />}
            />
            <Route path="/services/marketing-services" element={<MarketingServices />} />
            <Route
              path="/services/transcranial-magnetic-stimulation"
              element={<TranscranialMagneticStimulation />}
            />
            <Route path="/services/emr-subscription" element={<EmrSubscription />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            {/* <Route path="/blog/:slug" element={<BlogDetail />} /> */}
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/frequently-asked-questions" element={<FrequentlyAsked />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/auth/admin/login" element={<Login mode="admin" />} />
          <Route path="/auth/admin/login/" element={<Login mode="admin" />} />
          <Route path="/auth/user/login" element={<Login mode="user" />} />
          <Route path="/auth/user/login/" element={<Login mode="user" />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />

          <Route path="/admin/login" element={<Navigate to="/auth/admin/login/" replace />} />
          <Route path="/admin/login/" element={<Navigate to="/auth/admin/login/" replace />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminApp basePath="admin" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminApp basePath="admin" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user"
            element={
              <ProtectedRoute>
                <AdminApp basePath="user" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/*"
            element={
              <ProtectedRoute>
                <AdminApp basePath="user" />
              </ProtectedRoute>
            }
          />
        </Routes>
      </CanonicalPath>
    </BrowserRouter>
  );
}

export default App;
